'use client';
import TravelersHero from '@/sections/travelersHero/TravelersHero';
import OptionsSection from '@/sections/optionsSection/OptionsSection';
import WhySection from '@/sections/whySection/WhySection';
import FeeCalculatorSection from '@/sections/feeCalculatorSection/FeeCalculatorSection';
import ToolsSection from '@/sections/toolsSection/ToolsSection';

export default function Travelers() {
  return (
    <main
      style={
        {
          // display: 'flex',
          // maxWidth: '1440px',
          // margin: '0 auto',
          // flexDirection: 'column',
          // justifyContent: 'center',
          // alignItems: 'center',
        }
      }
    >
      <TravelersHero />
      <OptionsSection />
      <WhySection />
      <FeeCalculatorSection />
      <ToolsSection />
    </main>
  );
}
